import { decorate, observable, reaction, action, configure } from 'mobx';
import { convertArrayToObject } from './utils';

configure({ enforceActions: 'always' });

class ProviderStore {
  constructor() {
    this.initialize();
  }

  setProperty = (key, value) => {
    this[key] = value;
  };

  initialize = () => {
    this.setProperty('providerSettings', []);
    this.setProperty('providerEvents', []);
    this.setProperty('language', 'en-us');
  };

}

decorate(ProviderStore, {
    initialize: action,
    language: observable,
    setProperty: action,
    setProviderSettings: action,
    providerSettings: observable,
    providerEvents: observable,
  });

  export default ProviderStore;